
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'

import getPageTitle from '@/utils/get-page-title'
import { mapGetters } from 'vuex'
import { parseTime } from '~/utils/validate.js'

export default {
	components: {
		TitleBox,
		TitleBox2
	},
	computed: {
		...mapGetters({
			userinfo: 'user/userinfo',
			token: 'user/token'
		})
	},
	data() {
		return {
			loading: null,
			blackContent: {
				resultName: '',
				result: null,
				createTime: null,
				info: null
			},
			// 显示第二个titleBox标题
			showDesc: false,
			search: '',
			leftImg: '',
			title: '', // 标题
			titleBoxTitle: '', // 第一个titleBox标题
			descTitle: '', // 第二个titleBox标题
			articleContent: '<p class="tc f18 text-aaa mt-115">加载中...</p>', // 内容
			time: null, //查询时间
			accountNumber: null //查询账号
		}
	},
	mounted() {
		// 黑号查询
		let title = '黑号查询'
		if (title) {
			this.getPageData(title)
		}
	},
	methods: {
		back() {
			this.$router.go(-1)
		},

		// 黑号查询
		getBlackRes() {
			if (!this.token) {
				this.$message.error('请先登录')
				this.$router.push(`/login?redirect=/blackSign`)

				// this.$router.push(
				//   `/login?redirect=/article/${this.search}`
				// );
				return
			}
			if (!this.search) {
				this.$message.warning('请输入要查询的账号')
				this.$nextTick(() => {
					this.$refs['search-input'].focus()
				})
				return
			}
			this.loading = true
			let p = {
				action: {
					type: 'blackNumber',
					account: this.search
				}
			}
			this.$api.checkNumber(p).then(res => {
				this.loading = false
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.time = `${parseTime(new Date(), '{y}-{m}-{d} {h}:{i}:{s}')}`
				this.blackContent = res.data
				this.accountNumber = this.search
			})
		},
		getPageData(title) {
			switch (title) {
				case '黑号查询':
					this.articleContent = ''
					this.showDesc = true
					this.leftImg = 'https://oss.pzds.com/img/Inquire.png'
					this.titleBoxTitle = this.title = '黑号查询'
					this.descTitle = '什么是黑号查询'
					break
				default:
					this.showDesc = false
					this.title = this.titleBoxTitle = title
			}
			this.getArticle()
			document.title = getPageTitle(this.title)
		},
		getArticle() {
			let p = {
				action: {
					title: this.title
				}
			}
			this.$api.articleDetail(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				this.articleContent = res.data ? res.data.content : '<p class="tc f18 text-aaa mt-115">暂无内容</p>'
			})
		}
	}
}
